import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookBookmark } from '@fortawesome/free-solid-svg-icons';
import commonFunc from './../common'
import _ from 'lodash';

const { getAllChildRoutes } = commonFunc;

const childRoutes = getAllChildRoutes()

const Home = () => {
  const [listFavorites, setListFavorites] = useState([])
  
  useEffect(() => {
    let currentFavorites = localStorage.getItem('my-favorites');
    if (currentFavorites) {
      currentFavorites = JSON.parse(currentFavorites)
    } else {
      currentFavorites = []
    }
    let favoriteRoutes = childRoutes.filter(route => currentFavorites.includes(route.url)).sort((a, b) => a.name.localeCompare(b.name))
    favoriteRoutes = _.uniqBy(favoriteRoutes, 'url')
    setListFavorites(favoriteRoutes)
  }, []);

  return (
    <div className="grid grid-cols-1 xl:grid-cols-1 xl:gap-4 min-h-screen">
      <div className="col-span-2 xl:col-auto ">
        <div className="p-4 mb-4 space-y-6 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className=" text-gray-400 rounded dark:border-gray-600">
            <h3 className='uppercase text-gray-700 dark:text-gray-200 font-medium border-l-4 border-blue-600 p-2'>
            <FontAwesomeIcon icon={faBookBookmark}/> Your Bookmark
            </h3>
          </div>
          <div className="text-gray-400 rounded dark:border-gray-600">
            <div className="grid grid-cols-3 xl:grid-cols-4 xl:gap-4">
              { listFavorites.map((page) => {
                return (
                  <div className="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                    <Link
                      to={ page.url }
                    >
                      <h5 className="mb-2 text-2xl font-semibold tracking-tight text-gray-700 dark:text-gray-200">
                        { page.icon } { page.name }
                      </h5>
                    </Link>
                  </div>
                )
              }) }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
